import { IStopSaleDetailState } from '../../types/stopSale/stopSalesTypes';
import endpoints from '../../utils/commonVariables/endpoints';
import {
    savableEntities,
    viewModelEntities,
} from '../../utils/commonVariables/entityKeys';
import { convertToOvariant } from '../../utils/convertToOvariant';
import { convertDateToUTC } from '../../utils/formatDates';
import { supplierHotelStopSaleViewModelStructure } from '../../utils/viewModelStructures/supplierHotelStopSale';
import api from '../api';

export const getStopSaleData = async (id: string) => {
    const endpoint = endpoints.viewModel(
        viewModelEntities.SupplierHotelStopSale,
        id
    );
    return api.post(endpoint, supplierHotelStopSaleViewModelStructure);
};

export const saveStopSaleToDDBB = async (
    stopSaleData: IStopSaleDetailState
) => {
    const adaptedStopSaleData = {
        ...stopSaleData,
        FromDate: stopSaleData.FromDate
            ? convertDateToUTC(stopSaleData.FromDate)
            : null,
        ToDate: stopSaleData.ToDate
            ? convertDateToUTC(stopSaleData.ToDate)
            : null,
    };
    const objectToSend = convertToOvariant(
        savableEntities.SupplierHotelStopSale,
        adaptedStopSaleData,
        adaptedStopSaleData.Id,
        supplierHotelStopSaleViewModelStructure
    );

    return api.post(endpoints.commonSave, objectToSend);
};
